import TextField from '../text-field/TextField'
import Typography from '../typography/Typography'
import tw, { styled } from 'twin.macro'

export const MortgageCalculatorContainerRoot = styled.div`
    ${tw`flex items-center`}
`

export const MortgageCalculatorInputRoot = styled(TextField)`
    ${tw`bg-grey-100 rounded-full h-10`}
`

export const MortgageCalculatorInputLabel = styled(Typography)`
    ${tw`text-basic-darkBlue !text-2xl`}
`
